import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
} from 'redux-saga/effects'

import {
  updateTablesAction,
} from 'containers/Entity/actions'

import {
  get,
  post,
  getRequest,
  jwtConfig,
  getEntityData
} from 'helpers/RequestUtil'

import {
  FETCH_NVBUG,
  FETCH_OTHER_PROJECT_LIST,
  FETCH_REC_PROJECT_LIST,
  POST_NVBUG_PROJECT,
} from './constants'

import {
  fetchOtherProjectListStart,
  fetchOtherProjectListSuccess,
  fetchOtherProjectListError,
  updateOtherProjectList,
  postNvbugProjectStart,
  postNvbugProjectSuccess,
  postNvbugProjectError,
  updatePage,
  fetchNvbugStart,
  fetchNvbugSuccess,
  fetchNvbugError,
  updateNvbugsId,
  updateRecProjectList,
  fetchRecProjectListStart,
  fetchRecProjectListSuccess,
  fetchRecProjectListError,
} from './actions'


import {
  buildUrl,
} from 'helpers/actionHelper'
import { clearNvbugsList, fetchNvbugs } from '../NvbugsCard/actions'

function* fetchOtherProjectList(query) {
  if (query === '') return
  try {
    yield put(fetchOtherProjectListStart())
    const params = [{ type: 'search', value: query }]
    const url = buildUrl('/api/fulcrum/manage/nvbugs/nvbug_unassociated_project_list_views', ...params)
    .concat(`&page[number]=${1}&page[size]=${20}`)
    const data = yield call(get, url)
    const { entities: { nvbug_unassociated_project_list_views: list } } = data
    yield put(updateTablesAction(data))
    yield put(fetchOtherProjectListSuccess())
    return list
  } catch(error) {
    yield put(fetchOtherProjectListError(error))
  }
}

function* fetchRecProjectList(nvbugId) {
  try {
    yield put(fetchRecProjectListStart())
    const url = buildUrl(`/api/fulcrum/manage/nvbugs/project_suggestions/${nvbugId}`)
    const data = yield call(getRequest, url, jwtConfig())
    yield put(fetchRecProjectListSuccess())
    return data && Array.isArray(data) ? data : []
  } catch(error) {
    yield put(fetchRecProjectListError(error))
  }
}

function* postNvbugProject(nvbugId, projectId) {
  try {
    yield put(postNvbugProjectStart())
    const postRequest = post('nvbug_links', { nvbugId, projectId })
    yield call(postRequest, '/api/fulcrum/manage/nvbugs/nvbug_links')
    yield put(postNvbugProjectSuccess())
    return true
  } catch(error) {
    yield put(postNvbugProjectError(error))
    return false
  }
}

function* fetchNvbug(nvbugId) {
  try {
    yield put(fetchNvbugStart())
    const url = buildUrl(`/api/fulcrum/manage/nvbugs/nvbug_unassociated_views/${nvbugId}`)
    const data = yield call(get, url)
    yield put(fetchNvbugSuccess())
    return getEntityData(data, 'nvbug_unassociated_views') 
  } catch(error) {
    yield put(fetchNvbugError(error))
    return false
  }
}

function* handleFetchOtherProjectList({ query }) {
  const projectList = yield call(fetchOtherProjectList, query)
  yield put(updateOtherProjectList(projectList ? projectList : []))
}

function* handleFetchRecProjectList({ nvbugId }) {
  const projectList = yield call(fetchRecProjectList, nvbugId)
  yield put(updateRecProjectList(projectList ? projectList : []))
}

function* handlePostNvbugProject({ nvbugId, projectId }) {
  const result = yield call(postNvbugProject, nvbugId, projectId)
  if (result) {
    yield put(updatePage(3))
    yield put(clearNvbugsList())
    yield put(fetchNvbugs())
  } else {
    yield put(updatePage(4))
  }
}

function* handleFetchNvbug({ nvbugId }) {
  const { nvbugId: bugId , synopsis } = yield call(fetchNvbug, nvbugId)
  if (bugId) yield put(updateNvbugsId(bugId, synopsis))
}

function* watchFetchOtherProjectList() {
  yield takeEvery(FETCH_OTHER_PROJECT_LIST, handleFetchOtherProjectList)
}

function* watchFetchRecProjectList() {
  yield takeEvery(FETCH_REC_PROJECT_LIST, handleFetchRecProjectList)
}

function* watchPostNvbugProject() {
  yield takeEvery(POST_NVBUG_PROJECT, handlePostNvbugProject)
}

function* watchFetchNvbug() {
  yield takeEvery(FETCH_NVBUG, handleFetchNvbug)
}

function* loadSagas() {
  yield all([
    fork(watchFetchOtherProjectList),
    fork(watchFetchRecProjectList),
    fork(watchPostNvbugProject),
    fork(watchFetchNvbug)
  ])
}

export default loadSagas
